export default __webpack_public_path__ + "static/kynnet5-0d9f8313a8c5f2cc072cfcce4f7fa0a5.jpeg";